import {TransactionColKey} from "../../../enums/TransactionColKey";
import {StorageKey} from "../../../enums/StorageKey";
import {withTransactionColumnInfo} from "../../Table/Transaction/withTransactionColumnInfo";
import {transactionColumnSortable} from "../../Table/Transaction/getTransactionColumnSortable";

const columns = [
    { key: TransactionColKey.number },
    { key: TransactionColKey.date },
    { key: TransactionColKey.number2 },
    { key: TransactionColKey.description },
    { key: TransactionColKey.transfer_from },
    { key: TransactionColKey.transfer_to },
    { key: TransactionColKey.tag_names },
    { key: TransactionColKey.amount },
    { key: TransactionColKey.status },
    { key: TransactionColKey.files },
    { key: TransactionColKey.created_at },
    { key: TransactionColKey.created_by },
    { key: TransactionColKey.action },
];

export default {
    storageKey: StorageKey.bank_transfer,
    required: [
        TransactionColKey.number,
        TransactionColKey.action,
    ],
    defaulto: [
        TransactionColKey.date,
        TransactionColKey.transfer_from,
        TransactionColKey.transfer_to,
        TransactionColKey.amount,
        TransactionColKey.status,
        TransactionColKey.files,
    ],
    sortable: transactionColumnSortable,
    getColumns: props => withTransactionColumnInfo(columns, props),
};
